import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  :root {
    --primary_color: #0f1111;
    --secondary_color: #CDD500;
    --gray_000: #fafafa;
    --gray_100: #f2f2f2;
    --gray_200: #f0f0f0;
    --gray_300: #ebebeb;
    --gray_400: #e3e3e3;
    --gray_500: #dcdcdc;
    --gray_600: #a0a0a0;
    --gray_800: #646464;
    --gray_900: #787878;
    --black_900: #0F1111;

    --red: #cc0233;
    --red_light: #ff4e4e;

    --green_so_club: #97c516;
    --green_bold: #063a22;
    --green_light: #b0dc1c;
    --green_blue: #115e67;
    --blue_ocean: #107a9f;
    --blue_light: #00a3ad;
    --blue_light_light: #ddedf6;
    --blue: #0067b9;

    --gray_bold: #303030;
    --gray_medium_bold: #555555;
    --gray: #656565;
    --gray_intermediary: #787878;
    --gray_medium: #aaaaaa;
    --gray_light_medium: #bcbcbc;
    --gray_light: #d9d9d9;
    --gray_disabled: #dddddd;
    --gray_light_light: #efefef;

    --white_gray_light: #fcfcfc;
    --white_gray: #f4f4f4;
    --white: #fff;

    --black: #0f1111;

    --gradient_blue: linear-gradient(to right, var(--blue_light), var(--primary_color));
    --gradient_green: linear-gradient(to right, var(--green_light), var(--green_blue));
    --gradient_black: linear-gradient(to right, var(--secondary_color), var(--black));

    --max-width: 90rem;
  }

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    font-family: 'Satoshi', sans-serif;
  }

  body {
    -webkit-font-smoothing: antialiased;
  }

  html {
    font-size: 16px;
  }

  button,
  a {
    cursor: pointer;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  img {
    object-fit: contain;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    list-style-type: none;
    margin: 0;
  }

  [disabled] {
    opacity: 0.5;
  }

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Para Firefox */
  input[type='number'][type='number'] {
    -moz-appearance: textfield;
  }

  .required::after {
    content: '*';
    position: relative;
    font-size: inherit;
    color: inherit;
    font-weight: inherit;
    padding-left: 0.2rem;
  }

  .scrolling {
    cursor: grabbing;
  }

  .loader {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 5px;
    animation-duration: 1.8s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: var(--primary_color);
    background: ${props => `linear-gradient(
    to right,
    var(--primary_color) 8%,
    #fff 25%,
    var(--primary_color) 33%
    )`};
    position: fixed;
    top: 0;
    right: 0;
    z-index: 101;
  }

  .slick-track {
    margin-left: 0 !important;
  }

  .x-price-old {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);
  }

  .x-price-old::before {
    transform: translate(-50%, -50%) rotate(10deg);
  }

  .x-price-old::after {
    transform: translate(-50%, -50%) rotate(-10deg);
  }

  .x-price-old::before,
  .x-price-old::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: var(--red);
    transform-origin: center;
    top: 50%;
    left: 50%;
  }

  .header .header-top,
  .header .header-navigation-tree-content,
  .header .header-navigation-section,
  .header-checkout .header-top,
  .home .component-title,
  .home > div,
  .home .product-carousel .swiper,
  .family-home .component-title,
  .family-home > div,
  .ultrapremio-info,
  .pdp .pdp-details .navigation-pages,
  .pdp .pdp-details .product,
  .pdp .previously-viewed,
  .pdp .product-rating-reviews,
  .footer > div > div,
  .footer .footer-about,
  .faq-container {
    width: 100%;
    max-width: var(--max-width);
    margin: 0 auto;
  }

  .simple-swiper {
    position: relative;
  }

  .simple-swiper .swiper-button-prev {
    left: -2.6rem;
  }

  .simple-swiper .swiper-button-next {
    right: -2.6rem;
  }

  .simple-swiper .swiper-button-prev,
  .simple-swiper .swiper-button-next {
    cursor: pointer;
    color: var(--black);
  }

  .simple-swiper .swiper-button-prev:after,
  .simple-swiper .swiper-button-next:after {
    font-size: 0.6rem;
    font-weight: 900;
  }

  .simple-swiper .swiper .swiper-button-prev,
  .simple-swiper .swiper .swiper-button-next {
    display: none;
  }

  .initial-pages-button {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: flex-end;
    min-height: 2.4rem;
    width: max-content;
    margin-top: 1rem;
    padding: 0.4rem 1.2rem;
    border: 0;
    border-radius: 0.2rem;
    background: var(--primary_color);
    border: 1px solid var(--primary_color);

    color: var(--white);
    text-transform: none;
    text-align: center;
    font-size: 1rem;
    font-weight: 700;

    transition: 0.3s;

    &.outline {
      color: var(--primary_color);
      background-color: var(--white);
    }
  }

  span.chevron-icon {
    width: 0.4rem;
    height: 0.4rem;
    border: solid var(--white);
    border-width: 3px 3px 0 0;
    display: inline-block;
    padding: 3px;
    background: transparent;
    cursor: pointer;

      &.down {
        transform: rotate(135deg);
      }

      &.up {
        transform: rotate(-45deg);
      }

      &.right {
        transform: rotate(45deg);
      }

      &.left {
        transform: rotate(-135deg);
      }

      &.transparent {
        color: transparent;
      }

      &.black {
        border-color: var(--black);
      }

      &.gray {
        border-color: var(--gray_medium);
      }

      &.mb-2 {        
          margin-bottom: 0.2rem;
      }
  }

  /* ________________MOBILE____________________ */
  @media (max-width: 1500px) {
    .header .header-top,
    .header .header-navigation-tree-content,
    .header .header-navigation-section,
    .header-checkout .header-top,
    .home .component-title,
    .home > div,
    .home .product-carousel .swiper,
    .family-home .component-title,
    .family-home > div,
    .pdp .previously-viewed,
    .pdp .product-rating-reviews,
    .footer > div > div,
    .footer .footer-about,
    .faq-container {
      max-width: calc(var(--max-width) - 10rem);
    }

    .order-address.primary-position {
      display: none;
    }

    .order-address.second-position {
      display: flex;
    }
  }

  @media (max-width: 1450px) {
    .header .header-top,
    .header .header-navigation-tree-content,
    .header .header-navigation-section,
    .header-checkout .header-top,
    .home .component-title,
    .home > div,
    .home .product-carousel .swiper,
    .family-home .component-title,
    .family-home > div,
    .pdp .previously-viewed,
    .pdp .product-rating-reviews,
    .footer > div > div,
    .footer .footer-about,
    .faq-container {
      max-width: calc(var(--max-width) - 20rem);
    }
  }

  @media (max-width: 1200px) {
    .family-home .component-title {
      padding: 0 1rem;
    }

    .simple-swiper .swiper-button-prev {
      left: 0 !important;
    }

    .simple-swiper .swiper-button-next {
      right: 0 !important;
    }
  }

  @media (max-width: 768px) {
    .checkbox .checkbox-item .item {
      gap: 1rem;
    }
  }

  @media (max-width: 726px) {
    .family-home .swiper-button-prev,
    .family-home .swiper-button-next {
      display: none;
    }
  }
  /* ________________MOBILE____________________ */
`;
